"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var wizard1;
            (function (wizard1) {
                class InitArgs {
                    constructor() {
                        this.isRecurringContext = false;
                        this.tasksCreate = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                }
                wizard1.init = init;
                function addEvents() {
                    $('#blankTask').on('click', function (event) {
                        event.preventDefault();
                        const returnAction = $('#ReturnAction').attr('value');
                        if (_initArgs.isRecurringContext)
                            parent.appn.location.navTo(_initArgs.tasksCreate, [
                                {
                                    name: 'isTaskRecurringContext',
                                    value: 'true'
                                },
                                {
                                    name: 'returnAction',
                                    value: returnAction
                                }
                            ]);
                        else
                            parent.appn.location.navTo(_initArgs.tasksCreate, [
                                { name: 'isTaskRecurringContext', value: 'false' },
                                { name: 'returnAction', value: returnAction }
                            ]);
                    });
                    $('#templateTask').on('click', function (event) {
                        const template = $('#Wizard_Template_Id').val();
                        if (template === undefined || template.length === 0)
                            event.preventDefault();
                    });
                }
            })(wizard1 = taskTemplates.wizard1 || (taskTemplates.wizard1 = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
